var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Box, Chip, Drawer, Grid, Menu, MenuItem, MenuList, styled, Typography, useMediaQuery } from "@mui/material";
import { useEffect, useState } from "react";
import { MuiButton, MuiStack } from "../../../components";
import NoDocumentFoundPage from "../../../components/templates/noDocumentsFoundPage";
import { grey } from "@mui/material/colors";
import { t } from "i18next";
import InfiniteScroll from "react-infinite-scroll-component";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Config } from "../../../api/config";
import { USER_PROFILE_DATA, ViewEstimateUrl } from "../../../api/url";
import { MoreIconNew, PlusIconWhite } from "../../../assets/images";
import DrawerHeader from "../../../components/atoms/DrawerHeader";
import { MuiIconButton } from "../../../components/atoms/iconButtonComponent";
import SkeletonLoader from "../../../components/atoms/sketeton";
import { DesktopTabComponent } from "../../../components/molecules/desktopTabComponent";
import CalendarGridComponent from "../../../components/templates/calendarGridComponent";
import ListPageHeaderComponent from "../../../components/templates/listPageHeaderComponent";
import { EListCardView, EMenuFeature, EModuleTypes, ESystemName, EUserRole, GridInitalPageSize, JC_ALERT_TYPES, LOCAL_STORAGE_KEYS, SERVICE_TYPE_ERROR_CODE, StatusEnum } from "../../../constants";
import { setIsLeftMenuOpen, setJobCardTaskDetailsSummary, showLoader } from "../../../redux/commonSlice";
import { getByIdAPI, getListAPI, resetState, setState } from "../../../redux/crudSlice";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { getLocalStorageItem } from "../../../utils/storageHelper";
import { dateFormate, formatDate, getCurrentWeekRange, getTime, scrollToTop } from "../../../utils/utils";
import { Filters } from "../filters";
import DataGridCommonComp from "../searchByType/dataGridCommonComp";
import ListCard from "./listCard";
import useAnalyticsEventTracker from "../../../utils/useAnalyticsEventTracker";
import { getStatusColor } from "../../../theme/statusColors";
import dayjs from "dayjs";
var Img = styled("img")(function (_ref) {
    var theme = _ref.theme;
    return {
        // height: "24px",
        width: "24px",
        height: '24px'
    };
});
var List = function (props) {
    var getModuleList = props.getModuleList, _a = props.listVariants, listVariants = _a === void 0 ? [] : _a, menusFeatures = props.menusFeatures, onClickCard = props.onClickCard, onClickCreateModule = props.onClickCreateModule, moduleListUrl = props.moduleListUrl, storeModuleName = props.storeModuleName, handleMenusClick = props.handleMenusClick, createButtonText = props.createButtonText, moduleName = props.moduleName, noDataTitle = props.noDataTitle, noDataSubTitle = props.noDataSubTitle, _b = props.pageTitle, pageTitle = _b === void 0 ? "" : _b, _c = props.isCreateButton, isCreateButton = _c === void 0 ? true : _c, itemData = props.itemData, _d = props.isMoreMenuVisible, isMoreMenuVisible = _d === void 0 ? true : _d, _e = props.isFinalInspector, isFinalInspector = _e === void 0 ? false : _e, loadingState = props.loadingState;
    var skeletonArray = Array.from({
        length: 4
    });
    var trackButtonClick = useAnalyticsEventTracker("List");
    var dispatch = useAppDispatch();
    var navigate = useNavigate();
    var isDesktop = useMediaQuery(function (theme) { return theme.breakpoints.up('sm'); });
    var _f = useState(""), searchText = _f[0], setSearchText = _f[1];
    var _g = useState(false), openFilter = _g[0], setOpenFilter = _g[1];
    var _h = useState([]), moduleList = _h[0], setModuleList = _h[1];
    var _j = useState(true), hasMore = _j[0], setHasMore = _j[1];
    var _k = useState(0), page = _k[0], setPage = _k[1];
    var _l = useState(null), anchorEl = _l[0], setAnchorEl = _l[1];
    var _m = useState({}), clickIndexItem = _m[0], setClickIndexItem = _m[1];
    var _o = useState([]), menus = _o[0], setMenus = _o[1];
    var _p = useState(true), isShowSkeleton = _p[0], setShowSkeleton = _p[1];
    var _q = useState(0), totalCount = _q[0], setTotalCount = _q[1];
    var _r = useState({
        page: 0,
        pageSize: GridInitalPageSize
    }), paginationModel = _r[0], setPaginationModel = _r[1];
    var auth = localStorage.getItem(LOCAL_STORAGE_KEYS.USER_LOGIN_DATA);
    var userProfile = localStorage.getItem(USER_PROFILE_DATA);
    var _s = useAppSelector(function (state) { return state.crud; }), filterValue = _s.filterValue, menuValue = _s.menuValue, selectedListViewType = _s.selectedListViewType, serviceType = _s.serviceType;
    var isAllViewActive = useAppSelector(function (state) { return state.common; }).isAllViewActive;
    var commonState = useSelector(function (state) { return state.common; });
    var selectedBranch = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_BRANCH);
    var _t = useState(), eventsList = _t[0], setEventList = _t[1];
    var _u = useState(), resources = _u[0], setResources = _u[1];
    var isMobileDrawer = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); }); // true for xs screens
    var isMobile = useMediaQuery(function (theme) { return theme.breakpoints.up("sm"); });
    var IS_DESKTOP = useMediaQuery(function (theme) { return theme.breakpoints.up("md"); });
    var upSM = useMediaQuery(function (theme) { return theme.breakpoints.up("sm"); });
    var dowMd = useMediaQuery(function (theme) { return theme.breakpoints.down("md"); });
    var IS_TABLET = upSM && dowMd;
    var upXS = useMediaQuery(function (theme) { return theme.breakpoints.up("xs"); });
    var downSM = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    var IS_MOBILE = upXS && downSM;
    var statusList = getLocalStorageItem(LOCAL_STORAGE_KEYS.STATUS_LIST);
    var serviceTypes = getLocalStorageItem(LOCAL_STORAGE_KEYS.SERVICE_TYPES);
    var _v = useState(listVariants.length > 0 && isAllViewActive ? listVariants[1] : listVariants.length > 0 && listVariants[0] ? listVariants[0] : ""), selectedListVariant = _v[0], setSelectedListVariant = _v[1];
    var selectedDesignationStorage = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_DESIGNATION);
    // const [selectedListVariant, setSelectedListVariant] =
    //   useState<string>(listVariants.length > 0 && isAllViewActive ? listVariants[1] : listVariants.length > 0 && listVariants[0] ? listVariants[0] : "");
    var open = Boolean(anchorEl);
    var userData = getLocalStorageItem(USER_PROFILE_DATA);
    var handleSearchChange = function (event) {
        setSearchText(event.target.value);
    };
    var handleShortcut = function (event) {
        if (auth && userProfile && (selectedDesignationStorage === null || selectedDesignationStorage === void 0 ? void 0 : selectedDesignationStorage.Name) === EUserRole.ServiceAdvisor) {
            var ctrlKey = event.ctrlKey, altKey = event.altKey, key = event.key;
            if (ctrlKey && altKey && key === "f") {
                event.preventDefault();
                setOpenFilter(true);
                // Your action to perform when the key is pressed
            }
            if (ctrlKey && altKey && key === "s") {
                var _document$getElementB;
                event.preventDefault();
                // setOpenFilter(true)
                (_document$getElementB = document.getElementById("searchAppointment")) === null || _document$getElementB === void 0 || _document$getElementB.focus();
                // Your action to perform when the key is pressed
            }
            if (ctrlKey && key === "a") {
                event.preventDefault();
                navigate("/appointment-create");
            }
            if (altKey && key === "b") {
                event.preventDefault();
                window.history.back();
            }
            if (ctrlKey && key === "d") {
                event.preventDefault();
                navigate("/dashboard");
            }
        }
    };
    var handleShortcutsOnKeyUp = function (event) { };
    var getJobCardStatus = function () { return __awaiter(void 0, void 0, void 0, function () {
        var request, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(moduleName && moduleName === EListCardView.JobCard)) return [3 /*break*/, 2];
                    request = {
                        SystemName: ESystemName.Jobcard
                    };
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: "statusList",
                            url: "".concat(Config.baseURL, "JobCard/BySystemName"),
                            request: request
                        }))];
                case 1:
                    response = _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        scrollToTop();
        getJobCardStatus();
    }, []);
    // document.addEventListener("keydown", handleShortcut);
    //document.addEventListener("onkeyup",handleShortcutsOnKeyUp)
    useEffect(function () {
        if (isDesktop && selectedListViewType == 'list' && getModuleList !== null && getModuleList !== void 0 && getModuleList.data) {
            setModuleList(__spreadArray([], (getModuleList === null || getModuleList === void 0 ? void 0 : getModuleList.data), true));
            setShowSkeleton(false);
        }
        else {
            if (getModuleList !== null && getModuleList !== void 0 && getModuleList.data) {
                var moduleItems = __spreadArray(__spreadArray([], moduleList, true), (getModuleList === null || getModuleList === void 0 ? void 0 : getModuleList.data), true);
                var result = [];
                var idMap = {};
                for (var _i = 0, moduleItems_1 = moduleItems; _i < moduleItems_1.length; _i++) {
                    var moduleItem = moduleItems_1[_i];
                    if (moduleItem && moduleItem.id) {
                        if (!idMap[moduleItem.id]) {
                            result.push(moduleItem);
                        }
                        idMap[moduleItem.id] = moduleItem.id;
                    }
                }
                setModuleList(moduleItems);
                setHasMore(true);
                setTotalCount(getModuleList === null || getModuleList === void 0 ? void 0 : getModuleList.TotalCount);
                //setHasMore(getModuleList?.count > moduleList.length ? true : false);
                setShowSkeleton(false);
                if ((getModuleList === null || getModuleList === void 0 ? void 0 : getModuleList.data.length) > 0) {
                    setPage(function (prev) { return prev + 1; });
                }
            }
        }
        // getEventListFunction()
        dispatch(setJobCardTaskDetailsSummary([]));
    }, [getModuleList]);
    useEffect(function () {
        setShowSkeleton(true);
    }, [filterValue]);
    useEffect(function () {
        if (isDesktop) {
            setPage(0);
            setModuleList([]);
            var pageSize = selectedListViewType === "calendar" ? 300 : GridInitalPageSize;
            getMainList(0, selectedListVariant, selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId, pageSize);
        }
        else {
            if (selectedBranch !== null && selectedBranch !== void 0 && selectedBranch.OrganizationId) {
                // debugger
                setPage(0);
                setModuleList([]);
                setTimeout(function () {
                    getMainList(0, selectedListVariant, selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId);
                }, 0);
                // setShowSkeleton(true)
            }
        }
    }, [filterValue, menuValue, selectedListVariant, serviceType]);
    var featureListData = function (index, el) {
        var finalMenus = [];
        if (menusFeatures != undefined && menusFeatures.length > 0) {
            switch (moduleName) {
                case "Appointment":
                    appointmentMenuFeatureList(index);
                    break;
                case "Inspection":
                    inspectionMenuFeatureList(el);
                    break;
                case "Estimate":
                    serviceEstimateMenuFeatureList(index);
                    break;
                case EListCardView.JobCard:
                    jobCardMenuFeatureList(index, el);
                    break;
                default:
                    setMenus(finalMenus);
            }
        }
    };
    var appointmentMenuFeatureList = function (index) {
        var _moduleList$index;
        if ((_moduleList$index = moduleList[index]) !== null && _moduleList$index !== void 0 && _moduleList$index.AssignedEmployeeId) {
            var _moduleList$index2;
            if (((_moduleList$index2 = moduleList[index]) === null || _moduleList$index2 === void 0 ? void 0 : _moduleList$index2.Key) == StatusEnum.Inward) {
                var filterReassign = menusFeatures.filter(function (item) { return item.Name === EMenuFeature.ReassignServiceAdvisor; });
                setMenus(filterReassign);
            }
            else {
                var filterReassign = menusFeatures.filter(function (item) { return !(item.Name === EMenuFeature.AssignServiceAdvisor); });
                setMenus(filterReassign);
            }
        }
        else {
            var filterAssign = menusFeatures.filter(function (item) { return item.Name === EMenuFeature.AssignServiceAdvisor; });
            setMenus(filterAssign);
        }
    };
    var serviceEstimateMenuFeatureList = function (index) {
        var _moduleList$index3, _moduleList$index4, _moduleList$index5;
        if (!(moduleList !== null && moduleList !== void 0 && (_moduleList$index3 = moduleList[index]) !== null && _moduleList$index3 !== void 0 && _moduleList$index3.AssignedEmployeeId)) {
            var filterMenuItems = menusFeatures.filter(function (item) { return item.Name === EMenuFeature.AssignServiceAdvisor; });
            setMenus(filterMenuItems);
            return;
        }
        if (moduleList && ((_moduleList$index4 = moduleList[index]) === null || _moduleList$index4 === void 0 ? void 0 : _moduleList$index4.Key) == StatusEnum.Approved) {
            setMenus(menusFeatures);
        }
        if (moduleList && ((_moduleList$index5 = moduleList[index]) === null || _moduleList$index5 === void 0 ? void 0 : _moduleList$index5.Key) === StatusEnum.Created) {
            var cancelFeature = menusFeatures === null || menusFeatures === void 0 ? void 0 : menusFeatures.filter(function (x) { return (x === null || x === void 0 ? void 0 : x.DisplayName) === "Cancel"; });
            setMenus(cancelFeature);
        }
        //  setMenus(menusFeatures)
    };
    var inspectionMenuFeatureList = function (el) {
        // setMenus(menusFeatures)
        viewEstimateFun(el);
    };
    var viewEstimateFun = function (el) { return __awaiter(void 0, void 0, void 0, function () {
        var filterMenuItems, _result$payload, _result$payload2, _result$payload3, requestBody, result, filterMenuItems, filterMenuItems, filterMenuItems, _result$payload4, _result$payload5, _result$payload6, requestBody, result, filterMenuItems, filterMenuItems, filterMenuItems;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(el.Key === StatusEnum.Open)) return [3 /*break*/, 1];
                    filterMenuItems = menusFeatures.filter(function (item) { return item.Name === EMenuFeature.Cancel; });
                    setMenus(filterMenuItems);
                    return [3 /*break*/, 5];
                case 1:
                    if (!(el.Key === StatusEnum.Completed)) return [3 /*break*/, 3];
                    requestBody = {
                        "PreJobCardDocumentId": el.InspectionId,
                        "HasChild": true
                    };
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: '',
                            url: ViewEstimateUrl,
                            request: requestBody
                        }))];
                case 2:
                    result = _a.sent();
                    if (result !== null && result !== void 0 && (_result$payload = result.payload) !== null && _result$payload !== void 0 && (_result$payload = _result$payload.data) !== null && _result$payload !== void 0 && _result$payload.PreJobCardDocumentId && result !== null && result !== void 0 && (_result$payload2 = result.payload) !== null && _result$payload2 !== void 0 && _result$payload2.success && (result === null || result === void 0 || (_result$payload3 = result.payload) === null || _result$payload3 === void 0 ? void 0 : _result$payload3.statusCode) == 200) {
                        if ((result === null || result === void 0 ? void 0 : result.payload.data.Key) === StatusEnum.ApprovalPending || (result === null || result === void 0 ? void 0 : result.payload.data.Key) === StatusEnum.Created) {
                            filterMenuItems = menusFeatures.filter(function (item) { return item.Name === EMenuFeature.ViewEstimate || item.Name === EMenuFeature.Cancel; });
                            setMenus(filterMenuItems);
                        }
                        else {
                            filterMenuItems = menusFeatures.filter(function (item) { return item.Name === EMenuFeature.ViewEstimate; });
                            setMenus(filterMenuItems);
                        }
                        // navigate(`/serviceEstimate-details-created/${result.payload.data.id}`)
                    }
                    else {
                        filterMenuItems = menusFeatures.filter(function (item) { return item.Name === EMenuFeature.GenerateEstimate || item.Name === EMenuFeature.Cancel; });
                        setMenus(filterMenuItems);
                    }
                    return [3 /*break*/, 5];
                case 3:
                    if (!(el.Key === StatusEnum.Converted)) return [3 /*break*/, 5];
                    requestBody = {
                        "PreJobCardDocumentId": el.InspectionId,
                        "HasChild": true
                    };
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: '',
                            url: ViewEstimateUrl,
                            request: requestBody
                        }))];
                case 4:
                    result = _a.sent();
                    if (result !== null && result !== void 0 && (_result$payload4 = result.payload) !== null && _result$payload4 !== void 0 && (_result$payload4 = _result$payload4.data) !== null && _result$payload4 !== void 0 && _result$payload4.PreJobCardDocumentId && result !== null && result !== void 0 && (_result$payload5 = result.payload) !== null && _result$payload5 !== void 0 && _result$payload5.success && (result === null || result === void 0 || (_result$payload6 = result.payload) === null || _result$payload6 === void 0 ? void 0 : _result$payload6.statusCode) == 200) {
                        if ((result === null || result === void 0 ? void 0 : result.payload.data.Key) === StatusEnum.ApprovalPending || (result === null || result === void 0 ? void 0 : result.payload.data.Key) === StatusEnum.Created) {
                            filterMenuItems = menusFeatures.filter(function (item) { return item.Name === EMenuFeature.ViewEstimate || item.Name === EMenuFeature.Cancel; });
                            setMenus(filterMenuItems);
                        }
                        else {
                            filterMenuItems = menusFeatures.filter(function (item) { return item.Name === EMenuFeature.ViewEstimate; });
                            setMenus(filterMenuItems);
                        }
                        // navigate(`/serviceEstimate-details-created/${result.payload.data.id}`)
                    }
                    else {
                        filterMenuItems = menusFeatures.filter(function (item) { return item.Name === EMenuFeature.GenerateEstimate || item.Name === EMenuFeature.Cancel; });
                        setMenus(filterMenuItems);
                    }
                    _a.label = 5;
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var jobCardMenuFeatureList = function (index, el) {
        var _moduleList$index6, _moduleList$index7, _moduleList$index8, _moduleList$index11;
        // if (isFinalInspector) {
        //   let filterMenus = menusFeatures.filter((item: any) => item.Name !== EMenuFeature.AssignFinalInspector)
        //   setMenus(filterMenus)
        // } else {
        //   if (moduleList[index]?.Key != "WorkCompleted") {
        //     let filterMenus = menusFeatures.filter((item: any) => item.Name !== EMenuFeature.AssignFinalInspector)
        //     setMenus(filterMenus)
        //   } else {
        //     setMenus(menusFeatures)
        //   }
        // }
        if (!(moduleList !== null && moduleList !== void 0 && (_moduleList$index6 = moduleList[index]) !== null && _moduleList$index6 !== void 0 && _moduleList$index6.AssignedEmployeeId)) {
            var FilteredMenu = menusFeatures.filter(function (element) { return element.Name === EMenuFeature.AssignServiceAdvisor; });
            setMenus(FilteredMenu);
            return;
        }
        var dynamicValues = (serviceTypes === null || serviceTypes === void 0 ? void 0 : serviceTypes.DynamicValues) || [];
        var changeServiceTypeMenu = menusFeatures.find(function (element) { return element.Name === EMenuFeature.ChangeServiceType; });
        var hasMatchingServiceType = dynamicValues.some(function (item) { return (item === null || item === void 0 ? void 0 : item.FromServiceTypeId) === (el === null || el === void 0 ? void 0 : el.RepairTypeId); });
        var statusesWithChangeServiceType = [StatusEnum.ReadyForWork, StatusEnum.WorkStarted, StatusEnum.WorkCompleted, StatusEnum.FinalInspection, StatusEnum.Rework, StatusEnum.InspectionCompleted];
        var menusList = menusFeatures !== null && menusFeatures !== void 0 ? menusFeatures : [];
        switch ((_moduleList$index7 = moduleList[index]) === null || _moduleList$index7 === void 0 ? void 0 : _moduleList$index7.Key) {
            case StatusEnum.ReadyForWork:
            case StatusEnum.AwaitingForParts:
            case StatusEnum.InitiateWork:
            case StatusEnum.WorkStarted:
            case StatusEnum.InspectionCompleted:
                menusList = menusFeatures.filter(function (element) { return element.Name !== EMenuFeature.AssignServiceAdvisor && element.Name !== EMenuFeature.AssignFinalInspector && element.Name !== EMenuFeature.ReassignFinalInspector && element.Name !== EMenuFeature.ViewSpareIssue && element.Name !== EMenuFeature.ChangeServiceType; });
                if (statusesWithChangeServiceType.includes((_moduleList$index8 = moduleList[index]) === null || _moduleList$index8 === void 0 ? void 0 : _moduleList$index8.Key)) {
                    if (changeServiceTypeMenu && hasMatchingServiceType) {
                        menusList.push(changeServiceTypeMenu);
                    }
                }
                setMenus(menusList);
                break;
            case StatusEnum.Error:
                menusList = menusFeatures.filter(function (element) {
                    var _moduleList$index9, _moduleList$index10;
                    if ((_moduleList$index9 = moduleList[index]) !== null && _moduleList$index9 !== void 0 && (_moduleList$index9 = _moduleList$index9.SourceMessage) !== null && _moduleList$index9 !== void 0 && _moduleList$index9.ErrorCode || (_moduleList$index10 = moduleList[index]) !== null && _moduleList$index10 !== void 0 && _moduleList$index10.ErrorCode || null === SERVICE_TYPE_ERROR_CODE) {
                        return element.Name !== EMenuFeature.AssignServiceAdvisor && element.Name !== EMenuFeature.AssignFinalInspector && element.Name !== EMenuFeature.ReassignFinalInspector && element.Name !== EMenuFeature.ReassignServiceAdvisor && element.Name !== EMenuFeature.ViewSpareIssue;
                    }
                    return element.Name !== EMenuFeature.AssignServiceAdvisor && element.Name !== EMenuFeature.AssignFinalInspector && element.Name !== EMenuFeature.ReassignFinalInspector && element.Name !== EMenuFeature.ReassignServiceAdvisor && element.Name !== EMenuFeature.ChangeServiceType && element.Name !== EMenuFeature.ViewSpareIssue;
                });
                if (statusesWithChangeServiceType.includes((_moduleList$index11 = moduleList[index]) === null || _moduleList$index11 === void 0 ? void 0 : _moduleList$index11.Key)) {
                    if (changeServiceTypeMenu && hasMatchingServiceType) {
                        menusList.push(changeServiceTypeMenu);
                    }
                }
                setMenus(menusList);
                break;
            case StatusEnum.ReadyForInvoice:
                menusList = menusFeatures.filter(function (element) { return element.Name !== EMenuFeature.AssignServiceAdvisor && element.Name !== EMenuFeature.AssignFinalInspector && element.Name !== EMenuFeature.ReassignFinalInspector && element.Name !== EMenuFeature.CreateNewSpareIssue && element.Name !== EMenuFeature.ChangeServiceType; });
                setMenus(menusList);
                break;
            case StatusEnum.WorkCompleted:
                menusList = menusFeatures.filter(function (element) { return element.Name !== EMenuFeature.AssignServiceAdvisor && element.Name !== EMenuFeature.ReassignFinalInspector && element.Name !== EMenuFeature.ViewSpareIssue && element.Name !== EMenuFeature.ChangeServiceType; });
                if (changeServiceTypeMenu && hasMatchingServiceType) {
                    menusList.push(changeServiceTypeMenu);
                }
                setMenus(menusList);
                break;
            case StatusEnum.FinalInspection:
            case StatusEnum.Rework:
                menusList = menusFeatures.filter(function (element) { return element.Name !== EMenuFeature.AssignServiceAdvisor && element.Name !== EMenuFeature.AssignFinalInspector && element.Name !== EMenuFeature.ViewSpareIssue && element.Name !== EMenuFeature.ChangeServiceType; });
                if (changeServiceTypeMenu && hasMatchingServiceType) {
                    menusList.push(changeServiceTypeMenu);
                }
                setMenus(menusList);
                break;
            case StatusEnum.Invoiced:
            case StatusEnum.Delivered:
            case StatusEnum.Cancelled:
                menusList = menusFeatures.filter(function (element) { return element.Name !== EMenuFeature.AssignServiceAdvisor && element.Name !== EMenuFeature.AssignFinalInspector && element.Name !== EMenuFeature.ReassignFinalInspector && element.Name !== EMenuFeature.ReassignServiceAdvisor && element.Name !== EMenuFeature.CreateNewSpareIssue && element.Name !== EMenuFeature.ChangeServiceType; });
                setMenus(menusList);
                break;
            default:
                break;
        }
    };
    var getList = function (selectedListVariant, selectedBranchId) {
        getMainList(page, selectedListVariant, selectedBranchId);
    };
    var getBranchId = function () {
        var _branchData$Organizat;
        var branchData = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_BRANCH);
        return (_branchData$Organizat = branchData === null || branchData === void 0 ? void 0 : branchData.OrganizationId) !== null && _branchData$Organizat !== void 0 ? _branchData$Organizat : null;
    };
    var getMainList = function (pageCount, listVariant, selectedBranchId) {
        var arguments_1 = arguments;
        return __awaiter(this, void 0, void 0, function () {
            var _filterValue$Status, _filterValue$BranchId, _response$payload, dateObject, gridCount, formattedStatus, branchId, request, key, _userData$data, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        gridCount = (arguments_1.length <= 3 ? 0 : arguments_1.length - 3) > 0 && (arguments_1.length <= 3 ? undefined : arguments_1[3]);
                        if (filterValue !== null && filterValue !== void 0 && filterValue.StartDocDate) {
                            dateObject = new Date(filterValue === null || filterValue === void 0 ? void 0 : filterValue.StartDocDate);
                            dateObject.setDate(dateObject.getDate() + 30);
                        }
                        formattedStatus = filterValue === null || filterValue === void 0 || (_filterValue$Status = filterValue.Status) === null || _filterValue$Status === void 0 ? void 0 : _filterValue$Status.map(function (itemlist) { return itemlist.Key; });
                        branchId = (_filterValue$BranchId = filterValue === null || filterValue === void 0 ? void 0 : filterValue.BranchId) !== null && _filterValue$BranchId !== void 0 ? _filterValue$BranchId : selectedBranchId;
                        if (!branchId) {
                            branchId = getBranchId();
                        }
                        request = _objectSpread(_objectSpread({}, isFinalInspector ? {
                            Branches: [branchId]
                        } : {
                            OrganizationId: branchId
                        }), {}, {
                            Status: formattedStatus ? formattedStatus : "",
                            FromDate: filterValue !== null && filterValue !== void 0 && filterValue.StartDocDate ? filterValue === null || filterValue === void 0 ? void 0 : filterValue.StartDocDate : "",
                            ToDate: filterValue !== null && filterValue !== void 0 && filterValue.EndDocDate ? filterValue === null || filterValue === void 0 ? void 0 : filterValue.EndDocDate : filterValue !== null && filterValue !== void 0 && filterValue.StartDocDate ? dateObject : "",
                            ProductId: filterValue !== null && filterValue !== void 0 && filterValue.ModelId ? filterValue === null || filterValue === void 0 ? void 0 : filterValue.ModelId : undefined,
                            take: gridCount ? gridCount : 10,
                            skip: gridCount ? pageCount * gridCount : pageCount * 10,
                            Type: (selectedDesignationStorage === null || selectedDesignationStorage === void 0 ? void 0 : selectedDesignationStorage.Name) == EUserRole.FloorSupervisor ? 'FS' : ''
                        });
                        key = listVariant == (listVariants.length > 0 ? listVariants[0] : "") ? false : true;
                        if (!key) {
                            request.IdentityId = userData === null || userData === void 0 || (_userData$data = userData.data) === null || _userData$data === void 0 ? void 0 : _userData$data.IdentityId;
                        }
                        if (filterValue !== null && filterValue !== void 0 && filterValue.ServiceAdvisorId) {
                            request.IdentityId = filterValue === null || filterValue === void 0 ? void 0 : filterValue.ServiceAdvisorId;
                        }
                        if (filterValue !== null && filterValue !== void 0 && filterValue.ServiceTypeId) {
                            request.RepairTypeId = filterValue === null || filterValue === void 0 ? void 0 : filterValue.ServiceTypeId;
                        }
                        return [4 /*yield*/, dispatch(showLoader({
                                isLoaderOpen: true
                            }))];
                    case 1:
                        _a.sent();
                        setShowSkeleton(true);
                        return [4 /*yield*/, dispatch(getListAPI({
                                key: storeModuleName,
                                url: moduleListUrl,
                                request: request
                            }))];
                    case 2:
                        response = _a.sent();
                        dispatch(setState({
                            key: "menuValue",
                            value: ''
                        }));
                        return [4 /*yield*/, dispatch(showLoader({
                                isLoaderOpen: false
                            }))];
                    case 3:
                        _a.sent();
                        getEventListMonthFunction(response === null || response === void 0 || (_response$payload = response.payload) === null || _response$payload === void 0 ? void 0 : _response$payload.value);
                        setShowSkeleton(false);
                        return [2 /*return*/];
                }
            });
        });
    };
    var handleSelectMenu = function (listVariant) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setShowSkeleton(true);
                    setSelectedListVariant(function () { return listVariant; });
                    setPaginationModel({
                        page: 0,
                        pageSize: GridInitalPageSize
                    });
                    dispatch(setState({
                        key: "filterValue",
                        value: ""
                    }));
                    return [4 /*yield*/, dispatch(setState({
                            key: "getMainList",
                            value: []
                        }))];
                case 1:
                    _a.sent();
                    if (!(selectedListVariant == listVariant)) {
                        setModuleList([]);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var handleClickMoreIcon = function (event, index, el) {
        event.stopPropagation();
        featureListData(index, el);
        setAnchorEl(event.currentTarget);
        itemData(el);
    };
    var handleMenusListClick = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            handleMenusClick(data);
            setAnchorEl(null);
            return [2 /*return*/];
        });
    }); };
    var handleClose = function (event) {
        event.stopPropagation();
        setAnchorEl(null);
    };
    //for data grid++++++
    var pageSizeOptions = [10, 20, 50, 100];
    var handlePaginationfun = function (newPageSize) {
        setPaginationModel(function (prevModel) { return _objectSpread(_objectSpread({}, prevModel), {}, {
            pageSize: newPageSize.pageSize
        }); });
        getMainList(newPageSize === null || newPageSize === void 0 ? void 0 : newPageSize.page, selectedListVariant, selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId, newPageSize.pageSize);
    };
    var getDateColumnName = function () {
        var columnName = "";
        if (moduleName === ESystemName.Appointment) {
            columnName = "".concat(t('APPOINTMENT_DATE_COLUMN_NAME'));
        }
        else if (moduleName === ESystemName.Inspection) {
            columnName = "".concat(t('INSPECTION_DATE_COLUMN_NAME'));
        }
        else if (moduleName === ESystemName.Estimate) {
            columnName = "".concat(t('ESTIMATE_DATE_COLUMN_NAME'));
        }
        else if (moduleName === ESystemName.Jobcard || moduleName === ESystemName.FinalInspection) {
            columnName = "".concat(t('JOB_CARD_DATE_COLUMN_NAME'));
        }
        return columnName;
    };
    var getTextColor = function (status) {
        var textColor;
        switch (status) {
            case 'Waiting':
                textColor = "#8593A3";
                break;
            case 'Rework':
                textColor = "#F5222D";
                break;
            case 'Started':
                textColor = "#3697FF";
                break;
            case 'Completed':
                textColor = "#52C41A";
                break;
            default:
                textColor = grey;
                break;
        }
        return textColor;
    };
    var getTextbgColor = function (status) {
        var bgColor;
        switch (status) {
            case 'Waiting':
                bgColor = "#F4F7FA";
                break;
            case 'Rework':
                bgColor = "#FFF1F0";
                break;
            case 'Started':
                bgColor = "#EEF6FF";
                break;
            case 'Completed':
                bgColor = "#F6FFED";
                break;
            default:
                bgColor = "#F6FFED";
                break;
        }
        return bgColor;
    };
    var getStatusBorderColor = function (status) {
        var borderColor;
        switch (status) {
            case 'Waiting':
                borderColor = "#DEE4EB";
                break;
            case 'Rework':
                borderColor = "#FFA39E";
                break;
            case 'Started':
                borderColor = "#AFD5FF";
                break;
            case 'Completed':
                borderColor = "#D9F7BE";
                break;
            default:
                borderColor = "#DEE4EB";
                break;
        }
        return borderColor;
    };
    var columns = __spreadArray(__spreadArray([
        // {
        //   field: 'Avatar',
        //   headerName: 'Avatar',
        //   width: 98,
        //   disableColumnMenu: true,
        //   headerAlign: 'left',
        //   renderCell: () => <Avatar />
        // },
        {
            field: moduleName !== ESystemName.Inspection ? 'ScheduleDateAndTime' : 'CreatedOn',
            headerName: getDateColumnName(),
            width: 180,
            headerAlign: 'left',
            disableColumnMenu: true,
            valueFormatter: function (val) {
                if (!val || !dayjs(val).isValid())
                    return '-';
                return dayjs(val).format('DD MMM, YYYY hh:mm A');
            }
        }
    ], (moduleName !== ESystemName.Inspection ? [{
            field: 'CreatedOn',
            headerName: 'Document Creation Date',
            width: 180,
            valueFormatter: function (val) {
                if (!val || !dayjs(val).isValid())
                    return '-';
                return dayjs(val).format('DD MMM, YYYY hh:mm A');
            },
            disableColumnMenu: true
        }] : []), true), [
        {
            field: 'Customer',
            headerName: 'Customer',
            width: 185,
            headerAlign: 'left',
            disableColumnMenu: true,
            valueFormatter: function (val) { return val || '-'; }
            // renderCell: (params: any) => (
            //   <MuiStack alignItems={'left'}>
            //     <Typography id={`given-name`} noWrap sx={{ fontSize: 'sm', fontWeight: 'medium', width: '160px', overflow: "hidden", whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
            //       {params.value ?? '-'}
            //     </Typography>
            //   </MuiStack>
            // ),
        }, {
            field: 'Alerts',
            headerName: 'Alerts',
            width: 185,
            headerAlign: 'left',
            disableColumnMenu: true,
            renderCell: function (params) {
                var _params$value, _params$value2;
                return /*#__PURE__*/ React.createElement(MuiStack, {
                    alignItems: 'left',
                    columnGap: 0.5
                }, (params === null || params === void 0 || (_params$value = params.value) === null || _params$value === void 0 ? void 0 : _params$value.length) > 0 ? /*#__PURE__*/ React.createElement(React.Fragment, null, params === null || params === void 0 || (_params$value2 = params.value) === null || _params$value2 === void 0 ? void 0 : _params$value2.map(function (alertItem, index) {
                    return (
                    /*#__PURE__*/
                    // <Box key={index} sx={{ display: 'inline-flex', justifyContent: 'space-evenly', borderRadius: '6px', backgroundColor: '#FFF7E5', placeItems: 'center', width: '75px', height: '22px' }}>
                    //   {/* <MuiStack sx={{ border: '1px solid #F5222D', borderRadius: '3px', height: '6px', width: '6px', backgroundColor: '#F5222D' }} /> */}
                    //   <Typography color={'#CC7A00'} variant="h3">
                    //   </Typography>
                    // </Box>
                    React.createElement(Chip, {
                        color: "warning",
                        variant: "filled",
                        shape: "rounded",
                        label: alertItem.AlertName === JC_ALERT_TYPES.Repeat ? "Revisited" : alertItem.AlertName,
                        sx: {
                            border: 0,
                            color: 'warning.600'
                        }
                    }));
                })) : /*#__PURE__*/ React.createElement(React.Fragment, null, "-"));
            }
        }, {
            field: 'Mobile',
            headerName: 'Mobile',
            width: 140,
            headerAlign: 'left',
            disableColumnMenu: true,
            renderCell: function (params) {
                var _params$value3;
                return /*#__PURE__*/ React.createElement(MuiStack, {
                    alignItems: 'left'
                }, /*#__PURE__*/ React.createElement(Typography, {
                    id: "mobile-number",
                    color: '#1B1D21',
                    sx: {
                        fontSize: '12px',
                        fontWeight: '500',
                        lineHeight: '18px'
                    }
                }, (_params$value3 = params.value) !== null && _params$value3 !== void 0 ? _params$value3 : '-'));
            }
        }, {
            field: 'RegistrationNo',
            headerName: "".concat(t("REGISTRATION_NO_COLUMN_NAME")),
            width: 160,
            headerAlign: 'left',
            disableColumnMenu: true,
            renderCell: function (params) {
                var _params$value4;
                return /*#__PURE__*/ React.createElement(MuiStack, {
                    alignItems: 'left'
                }, /*#__PURE__*/ React.createElement(Typography, {
                    id: "registrationNo",
                    variant: "h6",
                    color: '#1B1D21',
                    sx: {
                        fontSize: '12px',
                        fontWeight: '500',
                        lineHeight: '18px'
                    }
                }, (_params$value4 = params.value) !== null && _params$value4 !== void 0 ? _params$value4 : '-'));
            }
        }, {
            field: 'serviceType',
            headerName: 'Service Type',
            width: 180,
            headerAlign: 'left',
            disableColumnMenu: true,
            renderCell: function (params) {
                var _params$value5;
                return /*#__PURE__*/ React.createElement(MuiStack, {
                    alignItems: 'left'
                }, /*#__PURE__*/ React.createElement(Typography, {
                    id: "repair-type-name",
                    variant: "h6",
                    color: '#1B1D21',
                    sx: {
                        fontSize: '12px',
                        fontWeight: '500',
                        lineHeight: '18px',
                        width: '150px',
                        overflow: "hidden",
                        whiteSpace: 'nowrap',
                        textOverflow: 'ellipsis'
                    }
                }, (_params$value5 = params.value) !== null && _params$value5 !== void 0 ? _params$value5 : '-'));
            }
        }, {
            field: 'ServiceAdvisor',
            headerName: "".concat(t("SERVICE_ADVISOR_COLUMN_NAME")),
            width: 180,
            headerAlign: 'left',
            disableColumnMenu: true,
            renderCell: function (params) {
                var _params$value6;
                return /*#__PURE__*/ React.createElement(MuiStack, {
                    alignItems: 'left'
                }, /*#__PURE__*/ React.createElement(Typography, {
                    id: "service-advisor-given-name",
                    variant: "h6",
                    color: '#1B1D21',
                    sx: {
                        fontSize: '12px',
                        fontWeight: '500',
                        textTransform: 'capitalize',
                        lineHeight: '18px',
                        width: '150px',
                        overflow: "hidden",
                        whiteSpace: 'nowrap',
                        textOverflow: 'ellipsis'
                    }
                }, (_params$value6 = params.value) !== null && _params$value6 !== void 0 ? _params$value6 : '-'));
            }
        }, {
            field: 'Status',
            headerName: 'Status',
            width: 150,
            headerAlign: 'left',
            disableColumnMenu: true,
            renderCell: function (params) {
                return /*#__PURE__*/ React.createElement(Chip, _extends({
                    label: (params === null || params === void 0 ? void 0 : params.value) || '-',
                    size: "small"
                }, getStatusColor((params === null || params === void 0 ? void 0 : params.value) || ''), {
                    shape: "rounded"
                }));
            }
        }, {
            field: 'MenuIcon',
            headerName: '',
            width: 82,
            disableColumnMenu: true,
            renderCell: function (params) {
                var _params$row, _params$row2, _params$row3, _params$row4, _params$row5, _params$row6, _params$row8, _params$row9, _params$row10, _params$row12, _params$row13, _params$row14, _params$row15;
                return /*#__PURE__*/ React.createElement(MuiStack, {
                    display: 'flex',
                    justifyContent: 'center'
                }, isMoreMenuVisible && ((_params$row = params.row) === null || _params$row === void 0 ? void 0 : _params$row.Key) && (((_params$row2 = params.row) === null || _params$row2 === void 0 ? void 0 : _params$row2.Key) == StatusEnum.Cancelled || ((_params$row3 = params.row) === null || _params$row3 === void 0 ? void 0 : _params$row3.Key) == StatusEnum.Closed || ((_params$row4 = params.row) === null || _params$row4 === void 0 ? void 0 : _params$row4.Key) == StatusEnum.Awaiting || ((_params$row5 = params.row) === null || _params$row5 === void 0 ? void 0 : _params$row5.Key) == StatusEnum.Error || ((_params$row6 = params.row) === null || _params$row6 === void 0 ? void 0 : _params$row6.Key) == StatusEnum.Inward ? null : /*#__PURE__*/ React.createElement(MuiIconButton, {
                    id: "more-menu-icon",
                    style: {
                        height: "24px",
                        width: "24px"
                    },
                    onClick: function (event) {
                        var clickItemIndex = moduleList.findIndex(function (item) {
                            var _params$row7;
                            return item.id === (params === null || params === void 0 || (_params$row7 = params.row) === null || _params$row7 === void 0 ? void 0 : _params$row7.id);
                        });
                        handleClickMoreIcon(event, clickItemIndex, moduleList[clickItemIndex]);
                    }
                }, /*#__PURE__*/ React.createElement("img", {
                    id: "moreMenuIcon",
                    src: MoreIconNew,
                    alt: "settingIcon",
                    color: "#6A7682"
                }))), moduleName == ESystemName.Estimate && ((_params$row8 = params.row) === null || _params$row8 === void 0 ? void 0 : _params$row8.Key) && (((_params$row9 = params.row) === null || _params$row9 === void 0 ? void 0 : _params$row9.Key) == StatusEnum.Approved || ((_params$row10 = params.row) === null || _params$row10 === void 0 ? void 0 : _params$row10.Key) == StatusEnum.Created) && /*#__PURE__*/ React.createElement(MuiIconButton, {
                    id: "more-menu-icon",
                    style: {
                        height: "24px",
                        width: "24px"
                    },
                    onClick: function (event) {
                        var clickItemIndex = moduleList.findIndex(function (item) {
                            var _params$row11;
                            return item.id === (params === null || params === void 0 || (_params$row11 = params.row) === null || _params$row11 === void 0 ? void 0 : _params$row11.id);
                        });
                        handleClickMoreIcon(event, clickItemIndex, moduleList[clickItemIndex]);
                    }
                }, /*#__PURE__*/ React.createElement("img", {
                    id: "moreMenuIcon",
                    src: MoreIconNew,
                    alt: "settingIcon",
                    color: "#6A7682"
                })), moduleName == ESystemName.Inspection && ((_params$row12 = params.row) === null || _params$row12 === void 0 ? void 0 : _params$row12.Key) && (((_params$row13 = params.row) === null || _params$row13 === void 0 ? void 0 : _params$row13.Key) == StatusEnum.Completed || ((_params$row14 = params.row) === null || _params$row14 === void 0 ? void 0 : _params$row14.Key) == StatusEnum.Open || ((_params$row15 = params.row) === null || _params$row15 === void 0 ? void 0 : _params$row15.Key) == StatusEnum.Converted) && /*#__PURE__*/ React.createElement(MuiIconButton, {
                    id: "more-menu-icon",
                    style: {
                        height: "24px",
                        width: "24px"
                    },
                    onClick: function (event) {
                        var clickItemIndex = moduleList.findIndex(function (item) {
                            var _params$row16;
                            return item.id === (params === null || params === void 0 || (_params$row16 = params.row) === null || _params$row16 === void 0 ? void 0 : _params$row16.id);
                        });
                        handleClickMoreIcon(event, clickItemIndex, moduleList[clickItemIndex]);
                    }
                }, /*#__PURE__*/ React.createElement("img", {
                    id: "moreMenuIcon",
                    src: MoreIconNew,
                    alt: "settingIcon",
                    color: "#6A7682"
                })));
            }
        }
    ], false);
    var handlePageChange = function (event, newPage) {
        setPaginationModel(function (prevModel) { return _objectSpread(_objectSpread({}, prevModel), {}, {
            page: newPage - 1
        }); });
        handlePaginationfun({
            page: newPage - 1,
            pageSize: paginationModel.pageSize
        });
    };
    var handlePageSizeChange = function (newPageSize) {
        setPaginationModel(function (prevModel) { return _objectSpread(_objectSpread({}, prevModel), {}, {
            page: 0,
            pageSize: newPageSize
        }); });
        handlePaginationfun({
            page: 0,
            pageSize: newPageSize
        });
    };
    //-----------for data grid
    var getEventListFunction = function () {
        var _getModuleList$data, _getModuleList$data2;
        //Sorting advisor name as per desired format
        var finalId = 0;
        var sortedResources = [];
        getModuleList === null || getModuleList === void 0 || (_getModuleList$data = getModuleList.data) === null || _getModuleList$data === void 0 || _getModuleList$data.forEach(function (item) {
            var serviceAdvisorName = "".concat(item === null || item === void 0 ? void 0 : item.ServiceAdvisorGivenName, " ").concat(item === null || item === void 0 ? void 0 : item.ServiceAdvisorFamilyName);
            var obj = {};
            var tempResource = sortedResources.find(function (elem) { return serviceAdvisorName === (elem === null || elem === void 0 ? void 0 : elem.title); });
            // const uniqueId = sortedResources.find((elem: any) => serviceAdvisorName === elem?.title)
            if (!tempResource) {
                finalId = finalId + 1;
                obj = {
                    id: finalId,
                    title: serviceAdvisorName
                };
                sortedResources.push(obj);
            }
        });
        setResources(sortedResources);
        //Sorting event list as per desired format
        var sortedEventList = [];
        getModuleList === null || getModuleList === void 0 || (_getModuleList$data2 = getModuleList.data) === null || _getModuleList$data2 === void 0 || _getModuleList$data2.forEach(function (item) {
            var customerName = (item === null || item === void 0 ? void 0 : item.GivenName) != '' && (item === null || item === void 0 ? void 0 : item.FamilyName) != '' ? "".concat(item === null || item === void 0 ? void 0 : item.GivenName, " ").concat(item === null || item === void 0 ? void 0 : item.FamilyName) : item !== null && item !== void 0 && item.GivenName ? item === null || item === void 0 ? void 0 : item.GivenName : '';
            var serviceAdvisorName = "".concat(item === null || item === void 0 ? void 0 : item.ServiceAdvisorGivenName, " ").concat(item === null || item === void 0 ? void 0 : item.ServiceAdvisorFamilyName);
            var tempResource = sortedResources.find(function (elem) { return serviceAdvisorName === (elem === null || elem === void 0 ? void 0 : elem.title); });
            var obj = _objectSpread({
                start: new Date(Date.parse(item === null || item === void 0 ? void 0 : item.SlotStartTime)),
                end: new Date(Date.parse(item === null || item === void 0 ? void 0 : item.SlotEndTime)),
                title: customerName.trim(),
                desc: item === null || item === void 0 ? void 0 : item.RegistrationNo,
                resourceId: tempResource === null || tempResource === void 0 ? void 0 : tempResource.id
            }, item);
            sortedEventList.push(obj);
        });
        setEventList(sortedEventList);
    };
    var getEventListMonthFunction = function (monthData) {
        var _monthData$data, _monthData$data2;
        //Sorting advisor name as per desired format
        var finalId = 0;
        var sortedResources = [];
        monthData === null || monthData === void 0 || (_monthData$data = monthData.data) === null || _monthData$data === void 0 || _monthData$data.forEach(function (item) {
            var serviceAdvisorName = "".concat(item === null || item === void 0 ? void 0 : item.ServiceAdvisorGivenName, " ").concat(item === null || item === void 0 ? void 0 : item.ServiceAdvisorFamilyName);
            var obj = {};
            var tempResource = sortedResources.find(function (elem) { return serviceAdvisorName === (elem === null || elem === void 0 ? void 0 : elem.title); });
            // const uniqueId = sortedResources.find((elem: any) => serviceAdvisorName === elem?.title)
            if (!tempResource) {
                finalId = finalId + 1;
                obj = {
                    id: finalId,
                    title: serviceAdvisorName
                };
                sortedResources.push(obj);
            }
        });
        setResources(sortedResources);
        //Sorting event list as per desired format
        var sortedEventList = [];
        monthData === null || monthData === void 0 || (_monthData$data2 = monthData.data) === null || _monthData$data2 === void 0 || _monthData$data2.forEach(function (item) {
            var customerName = (item === null || item === void 0 ? void 0 : item.GivenName) != '' && (item === null || item === void 0 ? void 0 : item.FamilyName) != '' ? "".concat(item === null || item === void 0 ? void 0 : item.GivenName, " ").concat(item === null || item === void 0 ? void 0 : item.FamilyName) : item !== null && item !== void 0 && item.GivenName ? item === null || item === void 0 ? void 0 : item.GivenName : '';
            var serviceAdvisorName = "".concat(item === null || item === void 0 ? void 0 : item.ServiceAdvisorGivenName, " ").concat(item === null || item === void 0 ? void 0 : item.ServiceAdvisorFamilyName);
            var tempResource = sortedResources.find(function (elem) { return serviceAdvisorName === (elem === null || elem === void 0 ? void 0 : elem.title); });
            var obj = _objectSpread({
                start: new Date(Date.parse(item === null || item === void 0 ? void 0 : item.SlotStartTime)),
                end: new Date(Date.parse(item === null || item === void 0 ? void 0 : item.SlotEndTime)),
                title: customerName.trim(),
                desc: item === null || item === void 0 ? void 0 : item.RegistrationNo,
                resourceId: tempResource === null || tempResource === void 0 ? void 0 : tempResource.id
            }, item);
            sortedEventList.push(obj);
        });
        setEventList(sortedEventList);
    };
    var onClickDataGridRow = function (id) { return __awaiter(void 0, void 0, void 0, function () {
        var item;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dispatch(resetState(['previousJobCards', 'getAlertsByJobCardId']))];
                case 1:
                    _a.sent();
                    item = moduleList === null || moduleList === void 0 ? void 0 : moduleList.find(function (item) { return item.id === id; });
                    if (item) {
                        trackButtonClick("ButtonClickEvent", "".concat(moduleName) + "_Row_Click", undefined);
                        onClickCard(item);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var list = [{
            id: "1",
            name: "My Details",
            component: /*#__PURE__*/ React.createElement(React.Fragment, null)
        }, {
            id: "2",
            name: "Change password",
            component: /*#__PURE__*/ React.createElement(React.Fragment, null)
        }, {
            id: "3",
            name: "Settings",
            component: /*#__PURE__*/ React.createElement(React.Fragment, null)
        }];
    var onLeftDrawerClick = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            dispatch(setIsLeftMenuOpen(!commonState.isMenuOpen));
            return [2 /*return*/];
        });
    }); };
    var getRows = function () {
        var rows = [];
        var rowMap = {};
        for (var _i = 0, moduleList_1 = moduleList; _i < moduleList_1.length; _i++) {
            var item = moduleList_1[_i];
            var _item$Customer, _item$Customer2, _item$Customer3, _item$Customer4, _item$Customer5, _item$Customer6, _item$Customer7, _item$Customer8, _item$StatusName, _item$Key, _item$SourceMessage;
            var date = "";
            if (moduleName === ESystemName.Appointment) {
                var scheduleDate = item !== null && item !== void 0 && item.SlotStartTime ? dateFormate(item === null || item === void 0 ? void 0 : item.SlotStartTime) : "-";
                var scheduleTime = item !== null && item !== void 0 && item.SlotStartTime ? getTime(item === null || item === void 0 ? void 0 : item.SlotStartTime) : "-";
                date = "".concat(scheduleDate, " ").concat(scheduleTime);
            }
            else if (moduleName === ESystemName.Inspection) {
                date = item !== null && item !== void 0 && item.ScheduledDate ? dateFormate(item === null || item === void 0 ? void 0 : item.ScheduledDate) : "-";
            }
            else if (moduleName === ESystemName.Estimate) {
                var deliveryDate = item !== null && item !== void 0 && item.DeliveryDate ? dateFormate(item === null || item === void 0 ? void 0 : item.DeliveryDate) : "-";
                var deliveryTime = item !== null && item !== void 0 && item.DeliveryDate ? getTime(item === null || item === void 0 ? void 0 : item.DeliveryDate) : "-";
                date = "".concat(deliveryDate, " ").concat(deliveryTime);
            }
            else if (moduleName === ESystemName.Jobcard || moduleName === ESystemName.FinalInspection) {
                date = item !== null && item !== void 0 && item.DeliveryDate ? "".concat(dateFormate(item === null || item === void 0 ? void 0 : item.DeliveryDate), "  ").concat(getTime(item === null || item === void 0 ? void 0 : item.DeliveryDate)) : "-";
            }
            var row = {
                id: item.id,
                Customer: moduleName === EModuleTypes.Jobcard ? item !== null && item !== void 0 && (_item$Customer = item.Customer) !== null && _item$Customer !== void 0 && _item$Customer.GivenName || item !== null && item !== void 0 && (_item$Customer2 = item.Customer) !== null && _item$Customer2 !== void 0 && _item$Customer2.FamilyName ? "".concat(item === null || item === void 0 || (_item$Customer3 = item.Customer) === null || _item$Customer3 === void 0 ? void 0 : _item$Customer3.GivenName, " ").concat(item === null || item === void 0 || (_item$Customer4 = item.Customer) === null || _item$Customer4 === void 0 ? void 0 : _item$Customer4.FamilyName) : '-' : item !== null && item !== void 0 && item.GivenName || item !== null && item !== void 0 && item.FamilyName ? "".concat(item === null || item === void 0 ? void 0 : item.GivenName, " ").concat(item === null || item === void 0 ? void 0 : item.FamilyName) : '-',
                Mobile: moduleName === EModuleTypes.Jobcard ? item !== null && item !== void 0 && (_item$Customer5 = item.Customer) !== null && _item$Customer5 !== void 0 && _item$Customer5.CountryCode || item !== null && item !== void 0 && (_item$Customer6 = item.Customer) !== null && _item$Customer6 !== void 0 && _item$Customer6.MobileNumber ? "".concat(item === null || item === void 0 || (_item$Customer7 = item.Customer) === null || _item$Customer7 === void 0 ? void 0 : _item$Customer7.CountryCode, " ").concat(item === null || item === void 0 || (_item$Customer8 = item.Customer) === null || _item$Customer8 === void 0 ? void 0 : _item$Customer8.MobileNumber) : '-' : item !== null && item !== void 0 && item.CountryCode || item !== null && item !== void 0 && item.MobileNumber ? "".concat(item === null || item === void 0 ? void 0 : item.CountryCode, " ").concat(item === null || item === void 0 ? void 0 : item.MobileNumber) : '-',
                RegistrationNo: item !== null && item !== void 0 && item.RegistrationNo ? item === null || item === void 0 ? void 0 : item.RegistrationNo : '-',
                serviceType: item !== null && item !== void 0 && item.RepairTypeName ? item === null || item === void 0 ? void 0 : item.RepairTypeName : "-",
                ScheduleDateAndTime: date,
                CreatedOn: item !== null && item !== void 0 && item.CreatedOn ? formatDate(item === null || item === void 0 ? void 0 : item.CreatedOn) : '-',
                ServiceAdvisor: item !== null && item !== void 0 && item.ServiceAdvisorGivenName && item !== null && item !== void 0 && item.ServiceAdvisorFamilyName ? (item === null || item === void 0 ? void 0 : item.ServiceAdvisorGivenName) + " " + (item === null || item === void 0 ? void 0 : item.ServiceAdvisorFamilyName) : item !== null && item !== void 0 && item.ServiceAdvisorGivenName ? item === null || item === void 0 ? void 0 : item.ServiceAdvisorGivenName : '-',
                Status: (_item$StatusName = item === null || item === void 0 ? void 0 : item.StatusName) !== null && _item$StatusName !== void 0 ? _item$StatusName : '-',
                Key: (_item$Key = item === null || item === void 0 ? void 0 : item.Key) !== null && _item$Key !== void 0 ? _item$Key : "",
                deliveryDate: item.DeliveryDate,
                Alerts: item.Alerts,
                SourceDocumentNo: item.SourceDocumentNo,
                ErrorCode: item === null || item === void 0 || (_item$SourceMessage = item.SourceMessage) === null || _item$SourceMessage === void 0 ? void 0 : _item$SourceMessage.ErrorCode
            };
            if (!rowMap[String(item.id)]) {
                rows.push(row);
            }
            rowMap[String(item.id)] = String(item.id); // To remove duplicates.
        }
        return rows;
    };
    var onToggleViewChange = function (value) {
        dispatch(setState({
            key: "selectedListViewType",
            value: value
        }));
        setModuleList([]);
        var pageSize = value === 'calendar' ? 300 : GridInitalPageSize;
        getMainList(0, selectedListVariant, selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId, pageSize);
    };
    var monthFilterData = function (selectedBranchId, listVariant, StartDocDate, EndDocDate) { return __awaiter(void 0, void 0, void 0, function () {
        var _filterValue$Status2, _filterValue$BranchId2, _response$payload2, _response$payload3, _response$payload4, dateObject, gridCount, pageCount, formattedStatus, _a, weekStart, weekEnd, branchId, request, key, _userData$data2, response, result, _response$payload5, _response$payload$val, _response$payload6, TotalCount, iterations, index, _response$payload7, _response$payload8, _response$payload9, response_1, _response$payload10;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    gridCount = 300;
                    pageCount = 0;
                    if (filterValue !== null && filterValue !== void 0 && filterValue.StartDocDate) {
                        dateObject = new Date(filterValue === null || filterValue === void 0 ? void 0 : filterValue.StartDocDate);
                        dateObject.setDate(dateObject.getDate() + 30);
                    }
                    formattedStatus = filterValue === null || filterValue === void 0 || (_filterValue$Status2 = filterValue.Status) === null || _filterValue$Status2 === void 0 ? void 0 : _filterValue$Status2.map(function (itemlist) { return itemlist.Key; });
                    _a = getCurrentWeekRange(), weekStart = _a.from, weekEnd = _a.to;
                    branchId = (_filterValue$BranchId2 = filterValue === null || filterValue === void 0 ? void 0 : filterValue.BranchId) !== null && _filterValue$BranchId2 !== void 0 ? _filterValue$BranchId2 : selectedBranchId;
                    if (!branchId) {
                        branchId = getBranchId();
                    }
                    request = _objectSpread(_objectSpread({}, isFinalInspector ? {
                        Branches: [branchId]
                    } : {
                        OrganizationId: branchId
                    }), {}, {
                        Status: formattedStatus ? formattedStatus : "",
                        FromDate: StartDocDate ? StartDocDate : filterValue !== null && filterValue !== void 0 && filterValue.StartDocDate ? filterValue === null || filterValue === void 0 ? void 0 : filterValue.StartDocDate : weekStart,
                        ToDate: EndDocDate ? EndDocDate : filterValue !== null && filterValue !== void 0 && filterValue.EndDocDate ? filterValue === null || filterValue === void 0 ? void 0 : filterValue.EndDocDate : filterValue !== null && filterValue !== void 0 && filterValue.StartDocDate ? dateObject : weekEnd,
                        ProductId: filterValue !== null && filterValue !== void 0 && filterValue.ModelId ? filterValue === null || filterValue === void 0 ? void 0 : filterValue.ModelId : undefined,
                        take: gridCount ? gridCount : 10,
                        skip: gridCount ? pageCount * gridCount : pageCount * 10
                    });
                    key = listVariant == (listVariants.length > 0 ? listVariants[0] : "") ? false : true;
                    if (!key) {
                        request.IdentityId = userData === null || userData === void 0 || (_userData$data2 = userData.data) === null || _userData$data2 === void 0 ? void 0 : _userData$data2.IdentityId;
                    }
                    if (filterValue !== null && filterValue !== void 0 && filterValue.ServiceAdvisorId) {
                        request.IdentityId = filterValue === null || filterValue === void 0 ? void 0 : filterValue.ServiceAdvisorId;
                    }
                    if (filterValue !== null && filterValue !== void 0 && filterValue.ServiceTypeId) {
                        request.RepairTypeId = filterValue === null || filterValue === void 0 ? void 0 : filterValue.ServiceTypeId;
                    }
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: true
                        }))];
                case 1:
                    _b.sent();
                    return [4 /*yield*/, dispatch(getListAPI({
                            url: moduleListUrl,
                            request: request
                        }))];
                case 2:
                    response = _b.sent();
                    result = [];
                    if (!(response && response !== null && response !== void 0 && response.payload && response !== null && response !== void 0 && (_response$payload2 = response.payload) !== null && _response$payload2 !== void 0 && _response$payload2.value && (response === null || response === void 0 || (_response$payload3 = response.payload) === null || _response$payload3 === void 0 ? void 0 : _response$payload3.value.statusCode) === 200 && response !== null && response !== void 0 && (_response$payload4 = response.payload) !== null && _response$payload4 !== void 0 && _response$payload4.value)) return [3 /*break*/, 6];
                    result = response === null || response === void 0 || (_response$payload5 = response.payload) === null || _response$payload5 === void 0 ? void 0 : _response$payload5.value;
                    TotalCount = (_response$payload$val = response === null || response === void 0 || (_response$payload6 = response.payload) === null || _response$payload6 === void 0 || (_response$payload6 = _response$payload6.value) === null || _response$payload6 === void 0 ? void 0 : _response$payload6.TotalCount) !== null && _response$payload$val !== void 0 ? _response$payload$val : 0;
                    if (!(TotalCount > 999)) return [3 /*break*/, 6];
                    iterations = TotalCount / 999;
                    index = 0;
                    _b.label = 3;
                case 3:
                    if (!(index < Math.ceil(iterations))) return [3 /*break*/, 6];
                    return [4 /*yield*/, dispatch(getListAPI({
                            url: moduleListUrl,
                            request: _objectSpread(_objectSpread({}, request), {}, {
                                take: 999,
                                skip: 999 * (index + 1)
                            })
                        }))];
                case 4:
                    response_1 = _b.sent();
                    if (response_1 && response_1 !== null && response_1 !== void 0 && response_1.payload && response_1 !== null && response_1 !== void 0 && (_response$payload7 = response_1.payload) !== null && _response$payload7 !== void 0 && _response$payload7.value && (response_1 === null || response_1 === void 0 || (_response$payload8 = response_1.payload) === null || _response$payload8 === void 0 ? void 0 : _response$payload8.value.statusCode) === 200 && response_1 !== null && response_1 !== void 0 && (_response$payload9 = response_1.payload) !== null && _response$payload9 !== void 0 && _response$payload9.value) {
                        result = __spreadArray(__spreadArray([], result, true), (response_1 === null || response_1 === void 0 || (_response$payload10 = response_1.payload) === null || _response$payload10 === void 0 ? void 0 : _response$payload10.value), true);
                    }
                    _b.label = 5;
                case 5:
                    index++;
                    return [3 /*break*/, 3];
                case 6:
                    getEventListMonthFunction(result);
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: false
                        }))];
                case 7:
                    _b.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var hanleMonthToggle = function (startDate, endDate) {
        if (IS_DESKTOP || IS_TABLET) {
            monthFilterData(selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId, selectedListVariant, startDate, endDate);
        }
    };
    return /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        spacing: 0
        // height={moduleList && moduleList.length > 0 && moduleList.length > 2 ? '100' : '90vh'}
    }, IS_DESKTOP && /*#__PURE__*/ React.createElement(DesktopTabComponent, {
        sx: {
            width: "100%",
            paddingX: 1
        },
        tabVariant: "standard",
        items: list,
        showTabIndicator: true,
        bgColorApply: true
    }), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12
        // sx={{ padding: { xs: '20px 0px 0px 16px !important', sm: '0px 8px 0px 24px !important' } }}
    }, /*#__PURE__*/ React.createElement(ListPageHeaderComponent, {
        handleClickFilterIcon: function () { return setOpenFilter(function (prev) { return !prev; }); },
        selectedMenuItem: selectedListVariant,
        menus: listVariants.length > 0 ? listVariants : "",
        onSelectMenu: function (listVariant) { return handleSelectMenu(listVariant); },
        activeView: selectedListViewType,
        onToggleView: function (value) { return onToggleViewChange(value); },
        totalCount: getModuleList === null || getModuleList === void 0 ? void 0 : getModuleList.TotalCount,
        onClickCreateModule: onClickCreateModule,
        createButtonText: createButtonText,
        isCreateButton: isCreateButton,
        moduleName: moduleName,
        loadingState: loadingState
    })), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        md: 12,
        sm: 12,
        lg: 12,
        xl: 12
        // sx={{ padding: isDesktop ? '8px 8px 8px 24px !important' : '' }}
        ,
        px: {
            xs: 2,
            sm: 3
        },
        py: 2,
        height: selectedListViewType === "calendar" && moduleList.length > 0 ? '100svh' : 'auto',
        alignItems: 'center'
    }, isDesktop ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(React.Fragment, null, selectedListViewType === 'grid' && moduleList.length > 0 && /*#__PURE__*/ React.createElement(InfiniteScroll, {
        dataLength: moduleList.length,
        next: function () { return getList(selectedListVariant, selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId); },
        style: {
            justifyContent: "center",
            alignItems: "center"
        },
        hasMore: hasMore,
        loader: /*#__PURE__*/ React.createElement(React.Fragment, null)
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        spacing: 2,
        paddingBottom: 9
    }, moduleList.map(function (el, index) {
        return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12,
            sm: 6,
            md: 6,
            lg: 4,
            key: index
        }, /*#__PURE__*/ React.createElement(ListCard, {
            data: el,
            onCardClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, dispatch(resetState(['previousJobCards', 'getAlertsByJobCardId']))];
                        case 1:
                            _a.sent();
                            onClickCard(el);
                            trackButtonClick("ButtonClickEvent", "".concat(moduleName) + "_Card_Click", undefined);
                            return [2 /*return*/];
                    }
                });
            }); },
            isMoreMenuVisible: isMoreMenuVisible,
            parentComponent: moduleName,
            menusFeatures: menusFeatures,
            handleClick: function (event) {
                handleClickMoreIcon(event, index, el);
                trackButtonClick("ButtonClickEvent", "".concat(moduleName), undefined);
            },
            showViewDetailsButton: false
        })));
    }))), selectedListViewType === "calendar" && isDesktop && /*#__PURE__*/ React.createElement(CalendarGridComponent, {
        eventsList: eventsList,
        resourceData: resources,
        moduleName: moduleName,
        handleClick: function (event, index, selectedEvent) { return handleClickMoreIcon(event, index, selectedEvent); },
        handleClickViewDetails: function (el) {
            onClickCard(el);
            trackButtonClick("ButtonClickEvent", "".concat(moduleName) + "_Card_Click", undefined);
        },
        totalCount: eventsList && eventsList !== null && eventsList !== void 0 && eventsList.length ? eventsList === null || eventsList === void 0 ? void 0 : eventsList.length : 0,
        hanleMonthToggle: hanleMonthToggle
    }), selectedListViewType === "list" && isDesktop && moduleList.length > 0 && /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        maxHeight: '60%'
    }, /*#__PURE__*/ React.createElement(DataGridCommonComp, {
        getRowId: function (row) { return row.id; },
        onCardClick: onClickDataGridRow,
        isMoreMenuVisible: isMoreMenuVisible,
        parentComponent: moduleName,
        menusFeatures: menusFeatures,
        handleClick: function (event, index) { return handleClickMoreIcon(event, index, moduleList); },
        totalCount: getModuleList === null || getModuleList === void 0 ? void 0 : getModuleList.TotalCount,
        pageSizeOptions: pageSizeOptions
        // handlePaginationFunction={handlePaginationfun}
        ,
        paginationModel: paginationModel,
        rows: getRows(),
        columns: columns,
        handlePageChange: handlePageChange,
        handlePageSizeChange: handlePageSizeChange,
        loading: isShowSkeleton
    })), selectedListViewType !== "calendar" && moduleList.length === 0 && !isShowSkeleton && /*#__PURE__*/ React.createElement(NoDocumentFoundPage, {
        title: noDataTitle,
        paragraph: noDataSubTitle
    }))) : /*#__PURE__*/ React.createElement(React.Fragment, null, moduleList && moduleList.length > 0 ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(InfiniteScroll, {
        dataLength: moduleList.length,
        next: function () { return getList(selectedListVariant, selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId); },
        style: {
            justifyContent: "center",
            alignItems: "center"
        },
        hasMore: hasMore,
        loader: /*#__PURE__*/ React.createElement(React.Fragment, null)
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        spacing: 2,
        paddingBottom: 9
    }, moduleList.map(function (el, index) {
        return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12,
            sm: 6,
            md: 6,
            lg: 4,
            key: index
        }, /*#__PURE__*/ React.createElement(ListCard, {
            data: el,
            onCardClick: function () {
                onClickCard(el);
                trackButtonClick("ButtonClickEvent", "".concat(moduleName) + "_Card_Click", undefined);
            },
            isMoreMenuVisible: isMoreMenuVisible,
            parentComponent: moduleName,
            menusFeatures: menusFeatures,
            handleClick: function (event) {
                handleClickMoreIcon(event, index, el);
                trackButtonClick("ButtonClickEvent", "".concat(moduleName) + "_More_Icon_Click", undefined);
            },
            showViewDetailsButton: false
        })));
    })))) : /*#__PURE__*/ React.createElement(React.Fragment, null, !isShowSkeleton && /*#__PURE__*/ React.createElement(NoDocumentFoundPage, {
        title: noDataTitle,
        paragraph: noDataSubTitle
    })))), /*#__PURE__*/ React.createElement(MuiStack, {
        width: '100%',
        direction: 'column',
        spacing: 1.5,
        px: {
            xs: 2,
            sm: 3
        },
        py: 2
    }, IS_MOBILE || selectedListViewType === "grid" ? /*#__PURE__*/ React.createElement(React.Fragment, null, isShowSkeleton && /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        spacing: 1
    }, skeletonArray === null || skeletonArray === void 0 ? void 0 : skeletonArray.map(function () { /*#__PURE__*/ return React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 6,
        md: 6,
        lg: 4
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        width: '100%',
        padding: 1,
        direction: 'column',
        style: {
            height: '220px'
        }
    }, /*#__PURE__*/ React.createElement(SkeletonLoader, null))); }))) : /*#__PURE__*/ React.createElement(React.Fragment, null, isShowSkeleton && (skeletonArray === null || skeletonArray === void 0 ? void 0 : skeletonArray.map(function () { /*#__PURE__*/ return React.createElement(Box, {
        height: 60
    }, /*#__PURE__*/ React.createElement(SkeletonLoader, null)); })))), isCreateButton && IS_MOBILE && /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        bgcolor: "#F4F7FA",
        position: "fixed",
        bottom: 0,
        padding: 2,
        height: "69px",
        borderTop: '1px solid #DEE4EB',
        justifyContent: isMobile ? "center" : 'flex-end'
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12
        // md={3}
        ,
        lg: 4
        // position={"fixed"}
        // right={0}
        ,
        width: "80%"
        // paddingX={2}
    }, /*#__PURE__*/ React.createElement(MuiButton, {
        startIcon: /*#__PURE__*/ React.createElement("img", {
            height: 13,
            width: 13,
            src: PlusIconWhite
        }),
        size: "small",
        color: "primary",
        id: "createAppointmentButton",
        onClick: onClickCreateModule,
        name: 'New',
        variant: "contained",
        fullWidth: true,
        sx: {
            padding: '8px 12px',
            justifyContent: 'center',
            fontWeight: 'medium'
        }
    }))), /*#__PURE__*/ React.createElement(Menu, {
        id: "basic-menu",
        anchorEl: anchorEl,
        open: open,
        onClose: handleClose,
        disableScrollLock: true,
        MenuListProps: {
            "aria-labelledby": "basic-button",
            sx: {
                padding: 0
            }
        },
        slotProps: {
            paper: {
                sx: {
                    boxShadow: "0px 4px 6px -2px rgba(16, 24, 40, 0.03), 0px 12px 16px -4px rgba(16, 24, 40, 0.08)",
                    borderRadius: "8px",
                    border: "1px solid #DEE4EB"
                }
            }
        }
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        width: "auto"
    }, /*#__PURE__*/ React.createElement(MenuList, {
        sx: {
            width: "100%",
            padding: 0
        }
    }, menus && (menus === null || menus === void 0 ? void 0 : menus.map(function (item, index) {
        return /*#__PURE__*/ React.createElement(MenuItem, {
            id: item.Name,
            dense: true,
            key: index,
            sx: {
                width: "100%",
                height: "42px",
                borderBottom: index === menus.length - 1 ? "none" : "1px solid #DEE4EB",
                fontWeight: 500,
                fontSize: 14,
                fontFamily: "NotoSans-Medium",
                textTransform: 'capitalize'
            },
            onClick: function () { return handleMenusListClick(item); }
        }, item === null || item === void 0 ? void 0 : item.DisplayName);
    }))))), /*#__PURE__*/ React.createElement(Drawer
    //variant="persistent"
    // anchor={"right"}
    , {
        anchor: isMobileDrawer ? "bottom" : "right",
        open: openFilter,
        onClose: function () { return setOpenFilter(function (prev) { return !prev; }); },
        sx: {
            display: {
                xs: "block"
            },
            "& .MuiDrawer-paper": {
                width: !isMobileDrawer ? 400 : '100%',
                borderTopRightRadius: isMobileDrawer ? '12px' : 0,
                borderTopLeftRadius: isMobileDrawer ? '12px' : 0
            }
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        sx: {
            height: "100%"
        },
        role: "presentation"
    }, IS_DESKTOP && /*#__PURE__*/ React.createElement(DrawerHeader, null), /*#__PURE__*/ React.createElement(Filters, {
        parent: moduleName,
        handleOnClose: function () {
            setOpenFilter(false);
        },
        systemName: moduleName,
        selectedValue: selectedListVariant
    }))));
};
export default List;
